<!--<mat-spinner *ngIf="!isLoaded"></mat-spinner>-->
<!--{{educations | json}}-->
<br>
<mat-spinner *ngIf="!isLoaded"></mat-spinner>
<div *ngIf="isLoaded">
    <h2 *ngIf="educations.length > 0 ">{{globals.getLocalizedValue(header)}}</h2>
    <!--tarvitaanko tätä?
    <h2 *ngIf="educationType?.name">{{globals.getLocalizedValue(educationType?.name)}}</h2>
    -->

    
    <!-- <mat-card *ngIf="educationType?.description?.valueFi || educationType?.description?.valueSv" class="education-type-description">
        <app-markdown [body]="globals.getLocalizedValueForTitle(educationType?.description)"></app-markdown>
    </mat-card>
        koulutustyypin kuvausteksti-->
    

    <mat-accordion >
        <!-- #docregion basic-panel -->
        <!-- #docregion hide-toggle -->
          <mat-expansion-panel *ngFor="let education of educations; let i = index"  > <!--tabindex="0"-->
        <!-- #enddocregion hide-toggle -->
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="">{{globals.getLocalizedValueForTitle(education.name)}}</span>
              </mat-panel-title>
              <!--<mat-panel-description>
                This is a summary of the content
              </mat-panel-description>-->
            </mat-expansion-panel-header>
            
            <div class="">
                <!--kaksiportaiset koulutukset-->
                <!--tässä päätellään kaksiportaisuus sisällöstä-->
                <div class="programme-collection" *ngIf="isTwoCycleDegree(education?.children)" >

                    <div class="first-cycle">
                        <div *ngFor="let unit of education?.children">
                            <!-- First cycle (kandiporras, BA) -->
                            <!-- PROGRAMME, no period -->
                            <a *ngIf="unit.educationLevel == 'BA' && !period && unit?.type == 'PROGRAMME'"
                                class="programme-item collection-item"
                                [routerLink]="['/', globals.lang, globals.getDegreeProgramme(), unit.id]">
                                <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                            </a>
                            <!-- PROGRAMME, with period -->
                            <a *ngIf="unit.educationLevel == 'BA' && period && unit?.type == 'PROGRAMME'"
                                class="programme-item collection-item"
                                [routerLink]="['/', globals.lang, globals.getDegreeProgramme(), unit.id]"
                                [queryParams]="{period: period}">
                                <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                            </a>
                            <!-- OFFERING, no period -->
                            <a *ngIf="unit.educationLevel == 'BA' && !period && unit?.type == 'OFFERING'"
                                class="programme-item collection-item offering"
                                [routerLink]="['/', globals.lang, globals.getLocalizedOffering(), unit.code, unit.id]">
                                <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                            </a>
                            <!-- OFFERING, with period -->
                            <a *ngIf="unit.educationLevel == 'BA' && period && unit?.type == 'OFFERING'"
                                class="programme-item collection-item offering"
                                [routerLink]="['/', globals.lang, globals.getLocalizedOffering(), unit.code, unit.id]"
                                [queryParams]="{period: period}">
                                <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                            </a>
                        </div>
                    </div>

                    <div class="arrow" aria-hidden="true">
                        <div class="hide-on-med-and-up">
                            <i class="medium material-icons">keyboard_arrow_down</i>
                        </div>
                        <div class="hide-on-small-only ">
                            <i class="medium material-icons">keyboard_arrow_right</i>
                        </div>
                    </div>

                    <div class="second-cycle">
                        <div *ngFor="let unit of education?.children">
                            <!-- Second cycle (maisteriporras, not BA) -->
                            <!-- PROGRAMME, no period -->
                            <a *ngIf="unit.educationLevel != 'BA' && !period && unit?.type == 'PROGRAMME'"
                                class="programme-item collection-item"
                                [routerLink]="['/', globals.lang, globals.getDegreeProgramme(), unit.id]">
                                <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                            </a>
                            <!-- PROGRAMME, with period -->
                            <a *ngIf="unit.educationLevel != 'BA' && period && unit?.type == 'PROGRAMME'"
                                class="programme-item collection-item"
                                [routerLink]="['/', globals.lang, globals.getDegreeProgramme(), unit.id]"
                                [queryParams]="{period: period}">
                                <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                            </a>
                            <!-- OFFERING, no period -->
                            <a *ngIf="unit.educationLevel != 'BA' && !period && unit?.type == 'OFFERING'"
                                class="programme-item collection-item offering"
                                [routerLink]="['/', globals.lang, globals.getLocalizedOffering(), unit.code, unit.id]">
                                <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                            </a>
                            <!-- OFFERING, with period -->
                            <a *ngIf="unit.educationLevel != 'BA' && period && unit?.type == 'OFFERING'"
                                class="programme-item collection-item offering"
                                [routerLink]="['/', globals.lang, globals.getLocalizedOffering(), unit.code, unit.id]"
                                [queryParams]="{period: period}">
                                <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="programme-collection no-cycle" *ngIf="!isTwoCycleDegree(education?.children)">
                    <div *ngFor="let unit of education?.children">
                        <!-- PROGRAMME, no period -->
                        <a *ngIf="!period && unit?.type == 'PROGRAMME'"
                            class="programme-item collection-item"
                            [routerLink]="['/', globals.lang, globals.getDegreeProgramme(), unit.id]">
                            <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                        </a>
                        <!-- PROGRAMME, with period -->
                        <a *ngIf="period && unit?.type == 'PROGRAMME'"
                            class="programme-item collection-item"
                            [routerLink]="['/', globals.lang, globals.getDegreeProgramme(), unit.id]"
                            [queryParams]="{period: period}">
                            <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                        </a>
                        <!-- OFFERING, no period -->
                        <a *ngIf="!period && unit?.type == 'OFFERING'"
                            class="programme-item collection-item offering"
                            [routerLink]="['/', globals.lang, globals.getLocalizedOffering(), unit.code, unit.id]">
                            <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                        </a>
                        <!-- OFFERING, with period -->
                        <a *ngIf="period && unit?.type == 'OFFERING'"
                            class="programme-item collection-item offering"
                            [routerLink]="['/', globals.lang, globals.getLocalizedOffering(), unit.code, unit.id]"
                            [queryParams]="{period: period}">
                            <span class="title">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                        </a>
                    </div>
                </div>


            </div>

            <!--Koulutuskuvaukset-->
            <div *ngFor="let description of education?.descriptions" class="education-description" >
                <div *ngIf="globals.getLocalizedValue(description?.text)">
                    <div *ngIf="description.text.valueFi.length > 0 || description.text.valueSv.length > 0 || description.text.valueEn.length > 0" class="education-content">
                        <div>
                            <b>{{globals.getLocalizedValue(description.descriptionField.title)}}</b>
                            <p>
                                <app-markdown [body]="globals.getLocalizedValue(description?.text)"></app-markdown>
                            </p>
                        </div>
                    </div>
                </div>
            </div>


              
          </mat-expansion-panel>
    </mat-accordion>

</div>
